import React from "react";

const FlatList = ({
  renderItem = () => {},
  data = [],
  renderEmpty = () => {
    return (
      <div
        style={{ height: "400px" }}
        className=" w-100 d-flex justify-content-center align-items-center"
      >
        <div>
          <p>نتیجه‌ای با مشخصات مورد نظر شما پیدا نشد.</p>
          <div className="d-flex justify-content-center mt-3">
            <button className="primary-btn-outline">حذف فیلتر ها</button>
          </div>
        </div>
      </div>
    );
  },
}) => {
  if (data.length == 0) {
    return renderEmpty();
  }
  return data.map((item, count) => {
    return renderItem(item, count);
  });
};

export default FlatList;
